import {Directive, NgModule} from '@angular/core';

export {SdFormField} from './form-field';

@Directive({
  selector: 'input[sdInput], textarea[sdInput], input[sd-input], textarea[sd-input]',
  standalone: true,
  host: {
    class: 'sd-input sd-input-element w-full border-0 bg-transparent p-0 text-sm text-[var(--m365-text-primary,#111)] outline-none placeholder:text-[var(--m365-text-secondary,#6b6b70)]',
  },
})
export class SdInput {}

@NgModule({
  imports: [SdInput],
  exports: [SdInput],
})
export class SdInputModule {}
